import React, { HTMLAttributes } from 'react';

import { View } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';
import { WysiwygField, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SCREEN_NORMAL } from '../../../config/constants';
import { ParagraphArticleHighlights as Type } from '../../../types/uncinc_profile/paragraphs';

import './style.scss';
import { ButtonWrapper } from '../../../components';

interface ParagraphArticleHighlightsProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphArticleHighlights: React.FC<ParagraphArticleHighlightsProps> = ({ entity }) => {
  const paragraphArticleHighlights = entity.toJS();
  const title = paragraphArticleHighlights.field_title[0]?.value;
  const body = paragraphArticleHighlights.field_body[0]?.value;
  const link = paragraphArticleHighlights.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;

  const { width } = useWindowDimensions();
  const isMobile = width < SCREEN_NORMAL;

  return (
    <div className="Paragraph">
      <div className="ParagraphArticleHighlights row">

        <div className="ParagraphArticleHighlights__body col-12 col-md-5">
          <h2>{title}</h2>
          <WysiwygField
            className="text--large"
            html={body}
          />
          {(!isMobile && linkUrl) && (
            <ButtonWrapper
              href={linkUrl}
            >
              {linkTitle}
            </ButtonWrapper>
          )}
        </div>

        <div className="ParagraphArticleHighlights__articles col-12 col-md-6 offset-md-1">
          <View
            id="article"
            display="highlights"
          />
          {(isMobile && linkUrl) && (
            <ButtonWrapper
              href={linkUrl}
            >
              {linkTitle}
            </ButtonWrapper>
          )}
        </div>
      </div>
    </div>
  );
};

export default ParagraphArticleHighlights;
